import React, { useEffect } from "react";
import {
  AttachmentGenericElement,
  AttachmentGenericElementButton,
} from "types/conversationInbox";
import { MultiMediaProps } from ".";

const TemplateButton = ({
  btn,
}: {
  btn: AttachmentGenericElementButton;
}): JSX.Element => {
  if (btn.type === "open_url" && btn.url) {
    return (
      <a href={btn.url} target="_blank" rel="noopener noreferrer">
        {btn.title}
      </a>
    );
  }

  return <button>{btn.title}</button>;
};

const TemplateElement = ({
  element,
  setIsReady,
}: {
  element: AttachmentGenericElement;
  setIsReady: () => void;
}): JSX.Element => {
  const [isError, setError] = React.useState(false);

  const onError = () => {
    setIsReady();
    setError(true);
  };

  useEffect(() => {
    if (!element?.image_url) {
      setIsReady();
    }
  }, [element?.image_url, setIsReady]);

  return (
    <div className="bg-inbox-surface-sunken rounded-[10px_10px_0px_10px] p-2 [&_h4]:text-xs [&_h4]:leading-[14px] [&_h4]:text-ink-primary [&_h5]:font-[350] [&_h5]:text-[10px] [&_h5]:leading-3 [&_h5]:text-ink-secondary">
      {element?.image_url && (
        <div className="w-full h-[200px] flex items-center justify-center bg-inbox-border [&_p]:text-[10px] [&_p]:text-ink-muted [&_img]:w-full [&_img]:h-full [&_img]:object-cover">
          {isError ? (
            <p>No longer available in Sked</p>
          ) : (
            <img
              src={element.image_url}
              onLoad={setIsReady}
              onError={onError}
            />
          )}
        </div>
      )}
      <h4>{element.title}</h4>
      {element?.subtitle && <h5>{element.subtitle}</h5>}
      <div className="flex flex-col cursor-pointer [&_button]:bg-inbox-border [&_button]:rounded-[10px] [&_button]:text-xs [&_button]:leading-[14px] [&_button]:text-ink-primary [&_button]:border-none [&_button]:p-[14px] [&_button]:w-full [&_button]:my-[5px] [&_button]:text-center [&_button]:font-medium [&_a]:bg-inbox-border [&_a]:rounded-[10px] [&_a]:text-xs [&_a]:leading-[14px] [&_a]:text-ink-primary [&_a]:border-none [&_a]:p-[14px] [&_a]:w-full [&_a]:my-[5px] [&_a]:text-center [&_a]:font-medium [&_a]:no-underline [&_a:hover]:no-underline">
        {(element.buttons || []).map(
          (btn: AttachmentGenericElementButton, key) => (
            <TemplateButton key={key} btn={btn} />
          )
        )}
      </div>
    </div>
  );
};

export const MediaTemplate = ({
  media,
  setIsReady,
}: MultiMediaProps): JSX.Element => {
  return (
    <>
      {media.payload.generic?.elements.map(
        (element: AttachmentGenericElement, key) => (
          <TemplateElement
            key={key}
            element={element}
            setIsReady={setIsReady}
          />
        )
      )}
    </>
  );
};
